import { useMemo, useState } from "react";
import { Card, Divider, Empty, Input } from "antd";
import Title from "antd/es/typography/Title";
import { useDebounce } from "hooks/useDebounce";
import { FeatureRow } from "./featureRow/featureRow";
import styles from "./featureList.module.scss";

export const FeatureList = ({
  groups,
  activeKey,
  onSelect,
  groupCount,
  groupStatus,
}) => {
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  const onSearchChange = useDebounce((e) =>
    setDebouncedSearchTerm(e.target.value),
  );

  const filteredGroups = useMemo(() => {
    if (!debouncedSearchTerm.trim()) return groups;

    const searchLower = debouncedSearchTerm.toLowerCase();

    return groups.filter((group) => {
      if (group.name.toLowerCase().includes(searchLower)) return true;

      return group.permissions.some(
        (permission) =>
          permission.name.toLowerCase().includes(searchLower) ||
          permission.desc.toLowerCase().includes(searchLower),
      );
    });
  }, [groups, debouncedSearchTerm]);

  return (
    <Card bordered={false} bodyStyle={{ padding: 0 }}>
      <div style={{ padding: 16 }}>
        <Title level={5} style={{ fontWeight: 600 }} className="text-primary">
          Permission Groups
        </Title>
        <Input.Search
          placeholder="Search"
          onChange={onSearchChange}
          defaultValue={debouncedSearchTerm}
          allowClear
        />
      </div>
      <Divider style={{ margin: 0 }} />
      <div className={`${styles.featureList} scrollable-container`}>
        {filteredGroups.length === 0 ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          filteredGroups.map((group) => (
            <FeatureRow
              key={group.key}
              group={group}
              count={groupCount(group)}
              total={group.permissions.length}
              status={groupStatus(group)}
              active={group.key === activeKey}
              onClick={() => onSelect(group.key)}
            />
          ))
        )}
      </div>
    </Card>
  );
};
